// Deterministic PRNG (Lehmer / MINSTD): the same seed gives the same sequence on the server and in
// the browser, unlike Math.random().
function createRandom(seed) {
    const modulo = 2147483647;
    let state = (Math.abs(Math.trunc(seed)) % (modulo - 1)) + 1;
    return () => {
        state = (state * 16807) % modulo;
        return (state - 1) / (modulo - 1);
    };
}

// Returns a randomized copy of `array` (the input is left untouched).
// Any list rendered server side must pass a `seed`: without it the server render and the browser
// hydration draw two different orders and React aborts hydration with a text mismatch (minified
// error #418). The shared seed is generated once per SSR pass and lives in `store.app.randomSeed`.
export function shuffle(array, seed = null) {
    const random = seed === null || seed === undefined ? Math.random : createRandom(seed);
    const result = [...array];
    for(let index = result.length - 1; index > 0; index -= 1) {
        const target = Math.floor(random() * (index + 1));
        [result[index], result[target]] = [result[target], result[index]];
    }
    return result;
}

export function unique(array) {
    return array.filter((value, index, self) => self.indexOf(value) === index);
}

export function flat(array) {
    let ret = [];
    for(let i = 0; i < array.length; i += 1) {
        if(Array.isArray(array[i])) {
            ret = ret.concat(flat(array[i]));
        } else {
            ret.push(array[i]);
        }
    }
    return ret;
}
